<!--
@Author: MIYONGLE
@Desc: 发布求职
@Date: 2021-04-16 18时
-->

<template>
  <div>
    <div class="min-width-pc">
      <div class="title-txt">发布求职信息</div>
      <div class="setion-box">
        <el-form class="setion-box-form">
          <el-form-item class="pc-form-line" label="岗位分类：">
            <el-select v-model="paramQuery.posiClass" clearable placeholder="请选择" :popper-append-to-body="false">
              <el-option
                v-for="item in posiList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="pc-form-line" label="岗位名称：">
            <el-input type="text" v-model="paramQuery.postName" placeholder="请输入岗位名称" class="pc-form-item"></el-input>
          </el-form-item>
          <el-form-item class="pc-form-line" label="联系电话：">
            <el-input type="text" v-model="paramQuery.iphoneCode" placeholder="请输入联系电话" class="pc-form-item"></el-input>
          </el-form-item>
          <el-form-item class="pc-form-line" label="职位薪资：">
            <el-input type="text" v-model="paramQuery.posiSalary" placeholder="如：1000元" class="pc-form-item"></el-input>
          </el-form-item>
          <el-form-item class="pc-form-line" label="职位亮点：">
            <el-input type="textarea" v-model="paramQuery.posiHighlights" placeholder="请输入亮点描述" class="pc-form-item"></el-input>
          </el-form-item>
          <el-form-item class="pc-form-line" label="要求学历：">
            <el-select v-model="paramQuery.education" clearable placeholder="请选择" :popper-append-to-body="false">
              <el-option
                v-for="item in educationList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="pc-form-line" label="招聘人数：">
            <el-input type="text" v-model="paramQuery.numberPersons" placeholder="如：3人" class="pc-form-item"></el-input>
          </el-form-item>
          <el-form-item class="pc-form-line" label="经验要求：">
            <el-input type="text" v-model="paramQuery.requirement" placeholder="如：1-2年" class="pc-form-item"></el-input>
          </el-form-item>
          <el-form-item class="pc-form-line" label="岗位描述：">
            <!-- <textarea placeholder="请输入岗位描述" class="pc-form-item"></textarea> -->
            <el-input type="textarea" v-model="paramQuery.posiDesc" placeholder="请输入岗位描述" class="pc-form-item"></el-input>
          </el-form-item>
          <div class="submitBtn">立即发布</div>
        </el-form>
      </div>
    </div>
    
    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>
  </div>
</template>

<script type="text/javascript">
import pcFormDialog from '../../components/pcFormDialog.vue'
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  name: "job-post",
  data() {
    return {
      source: '',
      sourceF: "",
      paramQuery: {
        posiClass: '',
        postName: '',
        iphoneCode: '',
        posiSalary: '',
        posiHighlights: '',
        education: '',
        numberPersons: '',
        requirement: '',
        posiDesc: ''
      },

      posiList: [
        '服务员','洗碗工','清洁工'
      ],
      educationList: [
        '不限','本科','大专','研究生','博士'
      ]
    }
  },

  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=zpqz_fbqz' : '&pageFrom=zpqz_fbqz';  
    this.sourceF = this.source + "_f";
  },

  methods: {
  
    jumpPage(){
      eventBus.$emit("pcOperaDiaLog", true);
    },
  }
}
</script>
<style lang="scss">
  .min-width-pc{
  .setion-box{
    padding-bottom: 207px;
    .pc-form-line{
      display: flex;
      justify-content: space-between;
      .el-form-item__label{
        min-width: 70px;
        text-align: right;
        display: block;
      }
    }
    .el-form-item__content{
      width: 600px;
    }
    .el-select{
      width: 600px;
      height: 40px;
    }
    .el-select-dropdown__item{
      text-align: left;
      font-family: MicrosoftYaHei;
    }
    .el-textarea{
      color: #595959
    }
  }
}
</style>

<style lang="scss" scoped>
.banner-box{
  background:url('./../../../static/pc/产品服务/banner_product_2.png') no-repeat;
  background-size: cover;
  background-color: #111010;
  .text{
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 54px;
    text-align: left;
  }
  
}
.title-txt{
  margin-top: 181px;
}
.min-width-pc{
  width: 800px;
  .setion-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 41px;
    margin-top: 72px;
  }
}

.submitBtn{
  width: 206px;
  height: 48px;
  background: #1985FF;
  border-radius: 30px;
  border: 0;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #FFFFFF;
  line-height: 48px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}

.setion-box-form{
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/pc/jobPost.vue